//
import WarehouseModel from '@/models/Warehouse/WhWarehouse'
import UserModel from '@/models/General/GUser'

//
import { required } from '@/services/validations'
import DispatchRequestDetailHeaders from './headers'

//
export default () => [
    {
        name: 'g_from_supervisor_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemKey: 'id',
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Responsable',
            model: UserModel,
            noDataText: 'Sin empleados.',
            noObject: true,
            readonly: true,
            rules: [required],
        },
    },
    {
        name: 'wh_to_warehouse_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: 'name',
            itemValue: 'id',
            label: 'Destino',
            model: WarehouseModel,
            noDataText: 'Sin bodegas.',
            noObject: true,
            readonly: true,
            rules: [required],
        },
    },
    {
        name: 'wh_from_warehouse_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: 'name',
            itemValue: 'id',
            label: 'Origen',
            model: WarehouseModel,
            noDataText: 'Sin bodegas.',
            noObject: true,
            readonly: true,
            rules: [required],
        },
    },
    {
        name: 'g_to_supervisor_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemKey: 'id',
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Solicitante',
            model: UserModel,
            noDataText: 'Sin empleados.',
            noObject: true,
            readonly: true,
            rules: [required],
        },
    },
    {
        name: 'g_state_name',
        type: 'text-field',
        flex: {
            sm3: true,
            xs12: true,
        },
        props: {
            label: 'Estado',
            readonly: true,
        },
    },
    {
        name: 'wh_selected_products',
        type: 'data-table-model',
        flex: {
            'pt-0': true,
            xs12: true,
        },
        props: {
            checkable: true,
            class: 'v-card elevation-2 mb-4',
            headers: DispatchRequestDetailHeaders,
            noActions: true,
            noDataText: 'Sin productos.',
            noFilter: true,
            noExport: true,
            noHelper: true,
            noPagination: true,
            noSearch: true,
            showNativePagination: true,
            toolbarTitle: 'Lista de productos incluidos en la guía',
            toolbarColor: 'primary',
            toolbarDark: true,
            toolbarDense: true,
            rules: [required],
        },
    },
    {
        name: 'description',
        type: 'textarea',
        flex: {
            xs12: true,
        },
        props: {
            label: 'Descripción',
            readonly: true,
        },
    },
    {
        name: 'reception_comment',
        type: 'textarea',
        flex: {
            xs12: true,
        },
        props: {
            label: 'Comentario de recepción',
        },
    },
]
